import React, { useState, useEffect } from 'react';
import { TextField, Button, Grid, Typography, Container, Snackbar, Alert } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore'; // Import serverTimestamp
import { db } from '../../../firebase';
import { useLocation } from 'react-router-dom';

const PrizepollAdd = () => {
  const [formData, setFormData] = useState({
    amount: 0,
    contest_id: '',
    gift_name: '', // Not required now
    id: uuidv4(), // Generate a new ID for the contest
    image: '', // Not required now
    position: 0,
    timestamp: serverTimestamp(), // Use Firebase server timestamp
    userName: '',
  });

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');

  // Custom hook to get query params
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  const query = useQuery();

  // Set contest_id from URL
  useEffect(() => {
    const contestId = query.get('uid');
    if (contestId) {
      setFormData(prevData => ({
        ...prevData,
        contest_id: contestId,
      }));
    }
  }, [query]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Convert number strings to numbers where necessary
    const updatedValue = name === 'amount' || name === 'position'
      ? parseInt(value)
      : value;

    setFormData(prevData => ({
      ...prevData,
      [name]: updatedValue,
    }));
  };

  const handleSelectTopic = (topicTitle) => {
    setFormData(prevData => ({
      ...prevData,
      topic: topicTitle,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const contestData = {
        ...formData,
        timestamp: serverTimestamp(), // Use server timestamp for Firestore
      };

      const docRef = doc(db, 'prizepoll', contestData.id);
      await setDoc(docRef, contestData);
      
      setAlertSeverity('success');
      setAlertMessage('Contest data submitted successfully!');
      setShowAlert(true);
      
      // Clear form data after submission if needed
      setFormData({
        amount: 0,
        contest_id: contestData.contest_id,
        gift_name: '', // Reset gift_name
        id: uuidv4(),
        image: '', // Reset image
        position: 0,
        timestamp: serverTimestamp(),
        userName: '',
      });
    } catch (error) {
      console.error('Error submitting contest data:', error);
      setAlertSeverity('error');
      setAlertMessage(`Error: ${error.message}`);
      setShowAlert(true);
    }
  };

  const handleAlertClose = () => {
    setShowAlert(false);
  };

  return (
    <Container maxWidth="sm">
      <Typography variant="h5" align="center" gutterBottom>
        Contest Form
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Coin"
              name="amount"
              type="number"
              value={formData.amount}
              onChange={handleInputChange}
              required
            />
          </Grid>
          {/* Gift Name and Image fields are now optional */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Gift Name (optional)"
              name="gift_name"
              value={formData.gift_name}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Image URL (optional)"
              name="image"
              value={formData.image}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Position"
              name="position"
              type="number"
              value={formData.position}
              onChange={handleInputChange}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">Contest ID: {formData.contest_id}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </form>
      <Snackbar open={showAlert} autoHideDuration={6000} onClose={handleAlertClose}>
        <Alert onClose={handleAlertClose} severity={alertSeverity} sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default PrizepollAdd;
